import React from 'react';
import printQueueService from '../../services/api/printQueue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import CrecerCheckin from '../../components/eventsLogin/crecer';
import authService from '../../services/api/auth';
import { Button } from 'semantic-ui-react';
import EntryCheckpoint from '../events/reservation/entryCheckpoint';
import SeminaryCheckin from '../../components/eventsLogin/seminary';
import { CheckInComponent } from '../../assets/styles/components/CheckIn';
import { ShowGuestLeaders } from '../membersLeader/showLeaders';
import GuestPlainData from '../../components/helpers/guests/GuestPlainData';

const GuestData = (props) => {
  const {
    Attendant,
    resetForm,
    set_errorData,
    errorData,
    set_Attendant,
    getAttendantInfo,
    mode = 'crecer',
  } = props;
  const currentUser = authService.getCurrentUser();
  const [loading, set_loading] = React.useState(false);
  const [openVolLeaders, setOpenVolLeaders] = React.useState(false);

  function addToAPrintQueue() {
    const { name, lastName, phone } = Attendant;

    printQueueService
      .addToAPrintQueue({
        name: `${name} ${lastName}`,
        identification: phone,
      })
      .then((response) => {
        if (response.data.success) {
          Swal.fire(response.data.message);
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) Swal.fire(error.response.data.message);
      });
  }

  return (
    <CheckInComponent>
      <Button primary onClick={() => resetForm()}>
        Atrás
      </Button>
      <h1 className="CheckIn__title">
        {mode === 'servicio' ? 'Ingreso Servicio' : 'Ingreso Crecer'}
      </h1>
      <h2 className="CheckIn__subtitle" style={{ marginTop: 0 }}>
        Asistente
      </h2>
      <GuestPlainData
        guest={Attendant}
        onGuestUpdated={({ identification }) => getAttendantInfo(identification)}
      />
      <div>
        <ShowGuestLeaders
          Guest={Attendant}
          buttonText="Ver líder"
          setOpenVolLeaders={setOpenVolLeaders}
          openVolLeaders={openVolLeaders}
          getInfo={() => getAttendantInfo(Attendant.identification)}
          set_loading={set_loading}
          loading={loading}
        />
      </div>
      <p style={{ color: 'red' }}>{errorData}</p>

      {mode === 'servicio' && currentUser.status.includes('events') && (
        <Button onClick={() => addToAPrintQueue()}>Imprimir escarapela</Button>
      )}

      {mode === 'crecer' && (
        <>
          <CrecerCheckin
            Attendant={Attendant}
            location={props.location}
            eventDates={props.eventDates}
            set_Attendant={set_Attendant}
            resetForm={resetForm}
          />
          <SeminaryCheckin
            Attendant={Attendant}
            location={props.location}
            eventDates={props.eventDates}
            set_Attendant={set_Attendant}
            resetForm={resetForm}
          />
        </>
      )}

      {mode === 'servicio' && props.Attendant.reserved && (
        <EntryCheckpoint
          getAttendantInfo={getAttendantInfo}
          Attendant={Attendant}
          reserved={props.Attendant.reserved}
          set_errorData={set_errorData}
        />
      )}
    </CheckInComponent>
  );
};

export default GuestData;
